/**
 * Accordion Block – frontend.js
 *
 * Handles open/close toggling, keyboard navigation, and the
 * allowMultiple behaviour for ovaa-theme/block-accordion.
 *
 * Enqueue this script from your theme's functions.php:
 *
 *   wp_enqueue_script(
 *       'ovaa-accordion',
 *       get_template_directory_uri() . '/assets/dist/js/accordion.js',
 *       [],
 *       '1.0.0',
 *       true
 *   );
 */

(function () {
  "use strict";

  /**
   * Toggle a single item open or closed.
   *
   * @param {HTMLElement} button  The <button> header element.
   * @param {boolean}     force   If supplied, force open (true) or closed (false).
   */
  function toggleItem(button, force) {
    const content = document.getElementById(
      button.getAttribute("aria-controls"),
    );
    const isOpen = button.getAttribute("aria-expanded") === "true";
    const openNext = force !== undefined ? force : !isOpen;

    button.setAttribute("aria-expanded", String(openNext));
    button
      .closest(".ovaa-accordion-item")
      .classList.toggle("is-open", openNext);

    if (openNext) {
      content.removeAttribute("hidden");
    } else {
      content.setAttribute("hidden", "");
    }
  }

  /**
   * Initialise a single accordion wrapper.
   *
   * @param {HTMLElement} accordion  The `.ovaa-accordion` element.
   */
  function initAccordion(accordion) {
    const allowMultiple = accordion.dataset.allowMultiple === "true";
    const buttons = Array.from(
      accordion.querySelectorAll(
        ":scope > .ovaa-accordion-item > .ovaa-accordion-item__header",
      ),
    );

    buttons.forEach(function (button, index) {
      button.addEventListener("click", function () {
        const isOpen = button.getAttribute("aria-expanded") === "true";

        // Close all siblings unless allowMultiple is on
        if (!allowMultiple) {
          buttons.forEach(function (btn) {
            if (btn !== button) {
              toggleItem(btn, false);
            }
          });
        }

        toggleItem(button, !isOpen);
      });

      // ── Keyboard navigation (ARIA Accordion pattern) ──────────────
      button.addEventListener("keydown", function (e) {
        let targetIndex = null;

        switch (e.key) {
          case "ArrowDown":
            targetIndex = (index + 1) % buttons.length;
            break;
          case "ArrowUp":
            targetIndex = (index - 1 + buttons.length) % buttons.length;
            break;
          case "Home":
            targetIndex = 0;
            break;
          case "End":
            targetIndex = buttons.length - 1;
            break;
          default:
            return; // don't prevent default for other keys
        }

        e.preventDefault();
        if (targetIndex !== null) {
          buttons[targetIndex].focus();
        }
      });
    });
  }

  /**
   * Boot – called once the DOM is ready.
   */
  function boot() {
    document.querySelectorAll(".ovaa-accordion").forEach(initAccordion);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
